import { useCallback, useState } from "react"
import classNames from "classnames/bind"
import styles from './ForgotPassword.module.css'
import axiosClient from "../../services/axiosClient";
import RegisterContainer from "../Register/RegisterContainer";
import HeaderRegister from "../Register/HeaderRegister";
import FormItem from "../InfoUser/ChangePassword/FormItem/FormItem";
import { Button, Toast } from "../../components";
import { isValidateConfirm, isValidatePassword } from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const cx = classNames.bind(styles)
function ChangeNewPass() {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate()
    const tokenState = useLocation();
    const handleTypeOldPassword = (data) => {
        setOldPassword(data)
    }
    const handleTypeNewPassword = (data) => {
        setNewPassword(data)
    }

    const handleTypeConfirmPassword = (data) => {
        setConfirmPassword(data)
    }

    const changePasswordIfErrorAuth = async () => {
        try {
            const axiosConfig = axios.create({
                baseURL: `${process.env.REACT_APP_API_URL}`,
                headers: {
                    "content-type": "application/json",
                    authorization: `vinorsoft ${tokenState.state.token}`,
                }
            })
            await axiosConfig.put('/authenticator/changePassword/', {
                old_password: oldPassword,
                new_password: newPassword,
            })
            Toast.open('Thay đổi mật khẩu thành công', 'success')
            setTimeout(() => {
                navigate('/login')
            }, 2000)
        } catch (error) {
            if (error.response.data.old_password) {
                Toast.open('Mật khẩu cũ không đúng', 'danger')
            } else {
                Toast.open('Thay đổi mật khẩu không thành công', 'danger')
                // // console.log('Thay đổi mật khẩu không thành công mã lỗi', error);
            }
        }
    }

    const handleSubmitForm = () => {
        if (
            isValidatePassword(newPassword) &&
            isValidatePassword(confirmPassword) &&
            isValidateConfirm(newPassword, confirmPassword)
        ) {
            changePasswordIfErrorAuth()
        } else {
            Toast.open('Mật khẩu mới hoặc mật khẩu nhập lại không đúng', 'danger')
        }
    }

    return (
        <>
            <div id="__notification"></div>
            <RegisterContainer>
                <HeaderRegister header={'Đổi mật khẩu lần đầu'} backTo={'/login'} />
                <form className={cx('form-change-password')} onSubmit={handleSubmitForm}>
                    <FormItem
                        label={'Mật khẩu hiện tại'}
                        name={'oldPassword'}
                        values={oldPassword}
                        onChange={handleTypeOldPassword}
                        type={'password'}
                        rules={[
                            {
                                isRequire: true,
                                mess: 'Mật khẩu không được để trống'
                            },
                        ]}
                    />
                    <FormItem
                        label={'Mật khẩu mới'}
                        name={'newPassword'}
                        values={newPassword}
                        onChange={handleTypeNewPassword}
                        type={'password'}
                        warning={'Dài 6 - 20 kí tự, bao gồm cả chữ, số, viết hoa, viết thường và cả những kí tự đặc biệt'}
                        rules={[
                            {
                                isRequire: true,
                                mess: 'Mật khẩu không được để trống'
                            },
                        ]}
                    />
                    <FormItem
                        label={'Nhập lại mật khẩu'}
                        name={'confirmPassword'}
                        values={confirmPassword}
                        onChange={handleTypeConfirmPassword}
                        type={'password'}
                        rules={[
                            {
                                isRequire: true,
                                mess: 'Mật khẩu không được để trống'
                            },
                            {
                                confirm: newPassword,
                                mess: 'Mật khẩu nhập lại không giống'
                            }
                        ]}
                    />
                    <div className={cx('button-change')}>
                        <Button
                            onClick={handleSubmitForm}
                            title="Xác nhận"
                        />
                    </div>
                </form>
            </RegisterContainer>
        </>
    )
}

export default ChangeNewPass;